/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario verificador.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmVerificador from "../../ventas/FrmVerificador.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmVerificadorPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmVerificador">
      <FrmVerificador />
    </SizeSoftXFrmPortatil>
  );
}
